<template>
  <div>
    <v-layout row class="controlButtons">
      <v-flex xs4 sm4 d-flex offset-xs1 offset-md1 offset-lg1>
        <br />
        <v-select
          v-model="select"
          :items="$store.state.data.labels"
          box
          class="dropdown"
          label="Sector de Riego"
          @input="click(select)"
        />
      </v-flex>
      <!-- <v-flex lg2 md2 sm12 xs12>
        <v-btn class="control" round color="blue" dark @click="onClick">
          HUMEDAD
        </v-btn>
      </v-flex>
      <v-flex lg2 md2 sm12 xs12>
        <v-btn class="control" round color="blue" dark @click="onClick2">
          CE
        </v-btn>
      </v-flex>
      <v-flex lg2 md2 sm12 xs12>
        <v-btn class="control" round color="blue" dark @click="onClick3">
          radiación
        </v-btn>
      </v-flex> -->
      <v-layout row wrap >
        <v-flex md2 lg2>
          <v-checkbox v-model="humedad" :label="`HUMEDAD`" @change="onClick"></v-checkbox>
        </v-flex>
        <v-flex md2 lg2>
          <v-checkbox v-model="ce" :label="`CE` " @change="onClick2"></v-checkbox>
        </v-flex>
        <v-flex md2 lg2>
          <v-checkbox v-model="radiation " :label="`RADIACIÓN`" @change="onClick3"></v-checkbox>
        </v-flex>
      </v-layout>
        
        
      </v-container>
    </v-layout>

    <v-layout>
      <div class="container">
        <v-card id="alert-daily" class="card extra">
          <v-layout row>
            <v-flex v-show="humedad" lg6 md6>
              <div
                id="humedad"
                style="margin-top:20px; height:200px;"
              />
            </v-flex>

            <v-flex v-show="ce" lg6 md6>
              <div id="ce" style="margin-top:20px; height:200px;" />
            </v-flex>

            <v-flex v-show="radiation" lg6 md6>
              <div
                id="radiation"
                style="margin-top:20px; height:200px;"
              />
            </v-flex>
          </v-layout>
        </v-card>
      </div>

      <v-snackbar
        v-model="snackbar"
        :multi-line="true"
        :timeout="timeout"
        :top="true"
        :vertical="true"
      >
        {{ text }}
        <v-btn color="pink" flat @click="snackbar = false">
          Cerrar
        </v-btn>
      </v-snackbar>
    </v-layout>
  </div>
</template>

<script>
// const moment = require("moment-timezone");
import moment from "moment-timezone";

const DATE_FORMAT = "D, h:mmA";

export default {
  data() {
    return {
      modal: null,
      snackbar: false,
      text: "Error",
      timeout: 6000,
      select: null,
      humedad: false,
      ce: false,
      radiation: false,
    };
  },
  methods: {
    onClick() {
      if(this.ce == true && this.radiation == true) {
        this.ce = false
      }
      this.$Highcharts.chart("humedad").redraw();
 
    },
    onClick2() {
      if(this.ce == true && this.radiation == true) {
        this.radiation = false
      }
      this.$Highcharts.chart("ce").redraw();
    },
    onClick3() {
      if(this.ce == true && this.radiation == true && this.humedad == true) {
        this.ce = false
      }
      this.$Highcharts.chart("radiation").redraw();
    },
    async click(event) {
      this.click2();
      console.log(event);

      let id = this.$store.state.devices.find((x) => x.name === this.select)
        .sigfoxId;
      console.log(id);

      let date = new Date();
      let params = {
        sigfoxDeviceId: id,
        startDate: new Date(date.setDate(date.getDate() - 1))
          .toISOString()
          .toString(),
        endDate: new Date().toISOString().toString(),
      };

      console.log(params);

      let humedad = [];
      let ce = [];
      let res = [];

      await this.$axios
        .get(`https://listener.rabiahostal.com.mx/api/message/get-by-device`, { params })
        .then((data) => {
          res = data.data;
          console.log("TEST", res);
          humedad = res.map((x) => {
            return (x.humidity / 30) * 0.5 * 100;
          });
          ce = res.map((x) => {
            return x.electricConductivity / 10000;
          });

          console.log(date);
          console.log(humedad);
          console.log(ce);
          this.modal = true;
        });
      this.populateChart(date, humedad, ce, res);
    },
    async click2() {
      console.log("chuyooo");
      console.log(this.$store.state.meteo.sigfoxId);
      let id = this.$store.state.meteo.sigfoxId;
      console.log(id);

      let date = new Date();
      let params = {
        sigfoxDeviceId: id,
        startDate: new Date(date.setDate(date.getDate() - 1))
          .toISOString()
          .toString(),
        endDate: new Date().toISOString().toString(),
      };

      console.log(params);

      let solarRadiation = [];
      let res = [];

      await this.$axios
        .get(`https://listener.rabiahostal.com.mx/api/message/get-by-device`, { params })
        .then((data) => {
          res = data.data;
          console.log("TEST", res);
          solarRadiation = res.map((x) => {
            if (x.solarRadiation == undefined) {
              return (x.solarRadiation = 0);
            }
            return x.solarRadiation;
          });

          console.log(solarRadiation);
        });
      this.populateChartWeather(date, solarRadiation, res);
    },
    populateChart(date, humedad, ce, res) {
      const categories = res.map((x) => {
        const formatted = moment(x.date).format(DATE_FORMAT);
        console.log("before: ", x.date);
        console.log("after: ", formatted);
        return formatted;
      });

      this.$Highcharts.chart("humedad", {
        chart: {
          type: "areaspline",
          zoomType: "xy"
        },
        legend: {
          align: "left",
          verticalAlign: "top",
          x: 0,
          y: -5,
          floating: true,
        },
        title: {
          text: "",
        },
        credits: {
          enabled: false,
        },
        xAxis: {
          categories,
          visible: false,
        },
        yAxis: {
          min: 10,
          // max: 10,
          title: {
            text: "%",
          },
          plotLines: [
            {
              zIndex: 4,
              dashStyle: "Dash",
              color: "#FF0000",
              width: 1,
              value: 27,
              label: {
                text: "Capacidad de campo",
                align: "right",
              },
            },
          ],
        },
        series: [
          {
            // showInLegend: true,
            data: humedad,
            name: "Humedad",
          },
        ],
      });

      this.$Highcharts.chart("ce", {
        chart: {
          type: "areaspline",
          zoomType: "xy"
        },
        legend: {
          align: "left",
          verticalAlign: "top",
          x: 0,
          y: -5,
          floating: true,
        },
        title: {
          // text: "CE",
          text: "",
        },
        credits: {
          enabled: false,
        },
        xAxis: {
          categories,
          visible: false,
        },
        yAxis: {
          // min: 0,
          // max: 10,
          title: {
            text: "dS/m",
          },
          plotLines: [
            {
              zIndex: 3,
              dashStyle: "Dash",
              color: "#FF0000",
              width: 1,
              value: 50,
              label: {
                text: 50,
                align: "right",
              },
            },
          ],
        },
        series: [
          {
            // showInLegend: true,
            data: ce,
            name: "Conductividad Èlectrica",
          },
        ],
      });
    },
    populateChartWeather(date, radiation, res) {
      console.log("res", res);
      const categories = res.map((x) => {
        const formatted = moment(x.date).format(DATE_FORMAT);
        // console.log("before: ", x.date);
        // console.log("after: ", formatted);
        return formatted;
      });

      this.$Highcharts.chart("radiation", {
        chart: {
          type: "areaspline",
          zoomType: "xy"
        },
        legend: {
          align: "left",
          verticalAlign: "top",
          x: 0,
          y: -5,
          floating: true,
        },
        title: {
          // text: "Radiacion Solar",
          text: "",
        },
        credits: {
          enabled: false,
        },
        xAxis: {
          categories,
          visible: false,
        },
        yAxis: {
          // min: 0,
          // max: 10,
          title: {
            text: "watts/m2",
          },
          plotLines: [],
        },
        series: [
          {
            // showInLegend: true,
            data: radiation,
            name: "Radiación Solar",
            color: "#F4511E",
          },
        ],
      });
    },
  },
};
</script>

<style scoped>
.container {
  height: 400px !important;
  padding: 0px !important;
  position:static;
  display: inline-block;
  /* margin-left: -1%; */
  width: 110% !important;
}

.control {
  width: 150px;
}

.dropdown {
  font-size: 10px;
  max-width: 250px;
}

.highcharts-axis-labels {
  display: none !important;
}
</style>
